import React from 'react';
import {PageHero} from "../common/PageHero";

const members = [
    {name: 'Filip Heijnemans', role: 'Voorzitter', mail: 'filip.heijnemans@... (gmail.com)', gsm: ''},
    {name: 'Lieve Pillens', role: 'Secretaris', mail: 'lieve_pillens@... ( yahoo.com )', gsm: ''},
    {name: 'Lawrens Hales', role: 'Penningmeester', mail: 'lawrens.hales@... (hotmail.com)', gsm: ''},
    {name: 'Jonas Cornelis', role: 'Toogverantwoordelijke', mail: 'Cornelisjonas@ ... (hotmail.com)', gsm: ''},
    {name: 'Thomas Jenné', role: 'Jeugdverantwoordelijke', mail: 'thomas.jenne@... (hotmail.com)', gsm: ''},
    {name: 'Filip Heijnemans', role: 'Feestverantwoordelijke', mail: 'filip.heijnemans@... (gmail.com)', gsm: ''},
    {name: 'Guido Swaelen', role: 'Raadslid', mail: '', gsm: ''}
];

export const Board = () => {
    return (
        <>
            <PageHero title={'Het bestuur'}
                      badge={'Wie is wie'}
                      lead={'Bij vragen over de club kan u steeds terecht bij een van onderstaande bestuursleden. De mailadressen zijn niet vervolledigd om spam te vermijden.'}/>
            <div className={'ttc-section'}>
                <div className={'ttc-card-grid'}>
                    {members.map((member, idx) => (
                        <div className={'ttc-card'} key={idx}>
                            <p className={'ttc-eyebrow'}>{member.role}</p>
                            <h3 className={'ttc-card-title'}>{member.name}</h3>
                            {member.mail && <p className={'ttc-card-meta text-break'}>{member.mail}</p>}
                            {member.gsm && <p className={'ttc-card-meta'}>{member.gsm}</p>}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}
